import { Component, OnInit } from '@angular/core';
import { Meta } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-cookie-policy-page',
  templateUrl: './cookie-policy-page.component.html',
  styleUrls: ['./cookie-policy-page.component.scss']
})
export class CookiePolicyPageComponent implements OnInit {

  constructor(private translate: TranslateService,
    private metaTagService: Meta) {
  }

  ngOnInit(): void {
    this.translate.get('meta.cookie_policy').subscribe(value => {
      this.metaTagService.updateTag({
        name: 'description',
        content: value
      });
    });       
  }

}
